import request from '@/utils/request'
import API from './api'

//获取题目日志
export function getQuestionRecordAPI(data) {
  return request({
    url: API.GET_QUESTION_RECORD,
    method: 'post',
    data
  })
}

//获取关联关系日志
export function getRelationRecordAPI(data) {
  return request({
    url: API.GET_RELATION_RECORD,
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/API/question-record.js